module.exports = __webpack_public_path__ + "img/th.6d1c6ef9.svg";